export const TRANSPARENCY_BREAKPOINT = 0.2;
export const ProviderKey = {
    PRODUCTS: '215238eb-22a5-4c36-9e7b-e7c08025e04e_products',
    SERVICES: '13d21c63-b5ec-5912-8397-c3a5ddb27a97_bookingsServices',
    EVENTS: '140603ad-af8d-84a5-2c80-a0f60cb47351_eventId',
    BLOG_POSTS: '14bcded7-0066-7c35-14d7-466cb3f09103_blogPostSelectionService',
    COUPONS: '14d7032a-0a65-5270-cca7-30f599708fed_couponsPicker',
};
export var LogoType;
(function (LogoType) {
    LogoType["custom"] = "custom";
    LogoType["siteLogo"] = "siteLogo";
    LogoType["wixStudio"] = "wixStudio";
    LogoType["wixClassic"] = "wixClassic";
    LogoType["wixPayments"] = "wixPayments";
    LogoType["wixVibe"] = "wixVibe";
    LogoType["marketplace"] = "marketplace";
    LogoType["rise"] = "rise";
    LogoType["wixel"] = "wixel";
    LogoType["quickbooksAndClassic"] = "quickbooksAndClassic";
    LogoType["quickbooksAndStudio"] = "quickbooksAndStudio";
})(LogoType || (LogoType = {}));
export var WixComponentTypes;
(function (WixComponentTypes) {
    WixComponentTypes["classic"] = "wix_classic";
    WixComponentTypes["studio"] = "wix_studio";
    WixComponentTypes["payments"] = "wix_payments";
    WixComponentTypes["rise"] = "rise";
})(WixComponentTypes || (WixComponentTypes = {}));
//# sourceMappingURL=constants.js.map